import { Form, } from 'antd'
import { Editor } from 'draft-js';
import React, { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactDOM from 'react-dom';
import { useStyleMap } from '../../../hooks';
import { getAncestorFromType, getBlockStyle } from '../../RichEditor/utils';
import { transformTextToEditorState } from '../../../utils/dataSync';
import { useStore } from '../../../store/store';
import { navbarHeight } from '../../../constants/gridConfig';
import EditorWrapper from '../../common/EditorWrapper';
import ContextualMenu from '../../ContextualMenu/ContextualMenu';
import { MENU_PARENT } from '../../../constants/constants';
import { EditorProvider } from '../../../contexts/EditorContext';
import FloatyTextStyling from '../../Table/FloatyTextStyling';

// `unselectBoxOnFocus` : le formulaire plein écran désélectionne la box quand on
// entre dans la remarque. Le panel de droite, lui, n'existe que tant que la box
// est sélectionnée — s'y désélectionner ferait disparaître le champ en cours de
// frappe (les raccourcis clavier, eux, ignorent déjà les zones éditables, cf.
// isInTextInput dans EventManager).
const FormBoxRemark = ({ box, onBlur, form, disabled = false, unselectBoxOnFocus = true }) => {
  const { t } = useTranslation();
  const [focused, setFocused] = useState(false);
  const remark = Form.useWatch('remark')
  const styleMap = useStyleMap()
  const handleUnselectBox = useStore((state) => state.handleUnSelectBox)
  const configuration = useStore((state) => state.configuration)
  const editorRef = useRef()
  const isDisabled = disabled || box.from_linked_section

  const setEditorState = useCallback((fn) => {
    if (!form || isDisabled) return;
    const newEditorState = typeof fn === 'function' ? fn(form.getFieldValue("remark")) : fn
    form.setFieldValue("remark", newEditorState)
    if (typeof onBlur === 'function')
      onBlur()
  }, [form, onBlur, isDisabled])

  useLayoutEffect(() => {
    var root = document.querySelector(':root');
    root.style.setProperty('--remark-max-height', `${(window.innerHeight - navbarHeight) * 40 / 100 - 32 - 80 - 24 - 40}px`);
  }, [])

  const menuAncestorIds = useMemo(() => [box.id], [box.id])

  return (
    <EditorProvider setEditorState={setEditorState} editorState={remark}>
      <EditorWrapper boxId={box.id} editorState={remark}>
        <Form.Item
          className={`variable-editor__input remark ${focused ? 'focused' : ''} ${isDisabled ? 'disabled' : ''}`}
          label={t('remarks')}
          name="remark"
          initialValue={transformTextToEditorState(box.remark)}
          onBlur={onBlur}
          valuePropName='editorState'
          labelCol={{ span: 24 }}
          id={box.id}
        >
          <Editor
            readOnly={isDisabled}
            ref={editorRef}
            stripPastedStyles={true}
            onFocus={() => { if (unselectBoxOnFocus) handleUnselectBox(); setFocused(true) }}
            onBlur={(e) => {
              if (!e.relatedTarget ||
                (e.relatedTarget.className !== 'text-styling-component' &&
                  e.relatedTarget.className !== 'ant-select-selection-search-input')) {
                setFocused(false)
              }
            }}
            customStyleMap={styleMap}
            blockStyleFn={getBlockStyle}
            className='RichEditor-editor'
            style={{
              overflow: 'visible',
            }}
          />
        </Form.Item>
      </EditorWrapper >
      {focused && ReactDOM.createPortal(
        <ContextualMenu
          editorState={remark}
          setEditorState={setEditorState}
          withoutDelimiters={["@"]}
          menuAncestorType={getAncestorFromType(box.type, MENU_PARENT.remark)}
          menuAncestorIds={menuAncestorIds}
        />,
        document.getElementById('SelectionVariablePortal')
      )}
      {focused && ReactDOM.createPortal(
        <FloatyTextStyling
          editorState={remark}
          setEditorState={setEditorState}
          colors={configuration.colors}
        />,
        document.getElementById('SelectionVariablePortal')
      )}
    </EditorProvider>
  )
}

export default FormBoxRemark
